export const envFallbacks = {
  CASINO_ID: "casino-0ac1bb6d-a473-42a7-b5e0-5dbc87241122",
  PORTAL_API_URL: "https://t-sapi.bowa.awd-group.tech",
  NEXT_PUBLIC_PORTAL_API_URL: "https://t-sapi.bowa.awd-group.tech",
  SVARA_API_URL: "https://t-sapi.bowa.awd-group.tech",
  BOWA_API_URL: "https://t-gapi.bowa.awd-group.tech",
  EXPO_PUBLIC_GAME_API: "https://dev.vipsvara.com/api/game",
  WS_API_URL: "wss://t-ws.bowa.awd-group.tech/game",
  SVARA_WEB_URL: "https://t-svara.bowa.awd-group.tech/",
};
